export default __webpack_public_path__ + "static/media/tm.7b00a55c.svg";